export function ExpediaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="133 133 34 34"
      width="24"
      height="24"
      fill="none"
      style={{ stroke: 'none' }}
    >
      <path
        fill="#fdda32"
        style={{ stroke: 'none' }}
        d="M159.4,166.4h-18.9c-3.6,0-6.6-3-6.6-6.6v-18.9c0-3.6,3-6.6,6.6-6.6h18.9c3.7,0,6.6,3,6.6,6.6v18.9c0,3.7-2.9,6.6-6.6,6.6Z"
      />
      <path
        fill="#191e3b"
        style={{ stroke: 'none' }}
        d="M143.7,160.2v-3.1c0-.3-.2-.5-.5-.5h-3.1c-.3,0-.5.2-.5.5v3.1c0,.3.2.5.5.5h3.1c.3,0,.5-.2.5-.5Z"
      />
      <path
        fill="#191e3b"
        style={{ stroke: 'none' }}
        d="M160.2,157.5v-15.4c0-1.1-.9-2.1-2.1-2.1h-15.4c-.3,0-.5.1-.7.3l-3.1,3.1c-.2.2,0,.6.3.6h13.9l-8.6,8.6c-.2.2-.2.3-.2.6v2.3c0,.3.2.5.5.5h2.3c.3,0,.4,0,.6-.2l8.6-8.6v13.9c0,.3.3.5.6.3l3.1-3.1c.2-.2.3-.4.3-.7Z"
      />
    </svg>
  );
}
